module.exports = __webpack_public_path__ + "static/img/guide_.a5a5e5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide_.png
// module id = c7xN
// module chunks = 1